import { Component } from 'react';
import { connect } from 'react-redux';

import { fetchLoginAssistantContent } from 'store/ducks/loginAssistant/actions';
import LoginAssistant from 'components/LoginAssistant';

export class LoginAssistantWrapper extends Component {
  static fetchDataOnServer(store) {
    return store.dispatch(fetchLoginAssistantContent());
  }

  componentDidMount() {
    const { content, fetchLoginAssistantContent } = this.props;
    if (!content.retrieved) {
      fetchLoginAssistantContent();
    }
  }

  render() {
    const { content, content: { isEmpty } } = this.props;
    if (isEmpty) {
      return null;
    }

    return <LoginAssistant content={content} />;
  }
}

function mapStateToProps(state) {
  return {
    content: state.loginAssistant.content
  };
}

export default connect(mapStateToProps,
  {
    fetchLoginAssistantContent
  })(LoginAssistantWrapper);
